import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  icon?: React.ReactNode;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  icon,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-4 rounded-full font-bold text-lg transition-all duration-200 transform hover:-translate-y-1 active:translate-y-0 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-emerald-600 hover:bg-emerald-700 text-white focus:ring-emerald-500',
    secondary: 'bg-rose-500 hover:bg-rose-600 text-white focus:ring-rose-500',
    outline: 'bg-transparent border-2 border-rose-900 text-rose-900 hover:bg-rose-50 focus:ring-rose-900'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    window.location.href = 'https://shop.hydraglosslips.com/cart/47864410407160:1';
    if (props.onClick) {
      props.onClick(e);
    }
  };
  return <button className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} {...props} onClick={handleClick} data-id="element-246">
      {children}
      {icon ? icon : <ArrowRight className="ml-2 h-5 w-5" data-id="element-247" />}
    </button>;
}